import { useBrowserBlobConnectivityQuery } from '@sib/api';

export const useStorageConnectivityCheck = () => {
  const { isPending, isError, data } = useBrowserBlobConnectivityQuery();

  const storageConnectionFailed = !isPending && (isError || data === false);

  return { storageConnectionFailed };
};
